import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-6" }

import { onMounted, watch, computed } from 'vue';
import { usePaymentStore } from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentSectionGooglePay',
  props: {
    environment: {},
    gatewayMerchantId: {},
    merchantName: {},
    merchantId: {}
  },
  setup(__props: any) {

const isSSR = typeof window == 'undefined';
!isSSR && import('../../../node_modules/@google-pay/button-element/dist');
const props = __props;

const paymentStore = usePaymentStore();

const paymentRequest = computed(() => {
  const amt = Number(paymentStore.amount || '0');

  return {
    apiVersion: 2,
    apiVersionMinor: 0,
    allowedPaymentMethods: [
      {
        type: 'CARD',
        parameters: {
          allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
          allowedCardNetworks: ['AMEX', 'VISA', 'MASTERCARD'],
        },
        tokenizationSpecification: {
          type: 'PAYMENT_GATEWAY',
          parameters: {
            gateway: 'fatzebra',
            gatewayMerchantId: props.gatewayMerchantId,
          },
        },
      },
    ],
    merchantInfo: {
      merchantId: props.merchantId,
      merchantName: props.merchantName || 'RACQ',
    },
    transactionInfo: {
      totalPriceStatus: 'FINAL',
      totalPriceLabel: 'Total',
      totalPrice: amt.toFixed(2),
      currencyCode: 'AUD',
      countryCode: 'AU',
    },
  };
});

onMounted(() => {
  paymentStore.googlePay = true;
  const button = document.querySelector('google-pay-button') as any;
  if (button) {
    button.paymentRequest = paymentRequest.value;
  }
});

// Keep the underlying web component's paymentRequest in sync with reactive updates
watch(paymentRequest, (val) => {
  const button = document.querySelector('google-pay-button') as any;
  if (button) {
    button.paymentRequest = val;
  }
});

const onLoadPaymentData = (event: CustomEvent<any>) => {
  try {
    // Google Pay token - this is the raw ECv2 JSON string we must forward to Online Services
    const token: string | undefined =
      event?.detail?.paymentMethodData?.tokenizationData?.token ||
      event?.detail?.paymentMethodData?.tokenizationData?.tokenizationData?.token;

    if (!token) {
      console.error('Google Pay token missing from payment data');
      return;
    }

    // Store token and trigger the shared submit flow via submitPaymentCallback
    paymentStore.setGooglePayToken(token);
  } catch (err) {
    console.error('Failed to process Google Pay payment data', err);
  }
};

const onError = (error: any) => {
  console.error('Google Pay error', {
    statusCode: error?.statusCode,
    statusMessage: error?.statusMessage,
  });
};

return (_ctx: any,_cache: any) => {
  const _component_google_pay_button = _resolveComponent("google-pay-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-base-bold" }, "Continue with Google Pay", -1)),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-base-regular mt-2" }, " Google Pay is the fast, simple way to pay using the cards saved to your Google Account. ", -1)),
    (!isSSR)
      ? (_openBlock(), _createBlock(_component_google_pay_button, {
          key: 0,
          class: "mt-6",
          environment: _ctx.environment || 'TEST',
          ".buttonType": 'pay',
          ".buttonColor": 'black',
          onLoadpaymentdata: onLoadPaymentData,
          onError: onError
        }, null, 40, ["environment"]))
      : _createCommentVNode("", true)
  ]))
}
}

})